import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(-1)
  },
  alignLeft: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "&:last-child": {
      marginRight: 0
    }
  },
  alignRight: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "&:first-child": {
      marginLeft: 0
    }
  },
  alignCenter: {
    margin: theme.spacing(0, 0.5),
    marginBottom: theme.spacing(1),
    "&:first-child": {
      marginLeft: 0
    },
    "&:last-child": {
      marginRight: 0
    }
  },
  rightButtons: {
    textAlign: "right"
  },
  justifiedButtons: {
    display: "flex",
    flex: "1 1 auto"
  },
  centerButtons: {
    textAlign: "center"
  },
  splitButton: {
    flexGrow: 1,
    margin: theme.spacing(0, 0.5),
    "&:first-child": {
      marginLeft: 0
    },
    "&:last-child": {
      marginRight: 0
    }
  },
  stackedButton: {
    width: "100%",
    marginBottom: theme.spacing(1)
  }
}));
export default useStyles;